<template>
  <div class="watchRisk-main-content">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-s-release"></i> Watch Risk</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="createMainWatchRisk"
          ><i class="el-icon-plus"></i> Add Watch Risk</el-button
        >
      </div>
      <div>
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            label="Name"
            prop="name"
            min-width="200"
          >

          </el-table-column>
          <el-table-column
            label="Exactly Match"
            prop="exactlyMatch"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag :type="`${!scope.row.exactlyMatch ? 'info' : ''}`">
                {{ scope.row.exactlyMatch ? "Yes" : "No" }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column label="Action" prop="uid" width="180" align="center">
            
            <template slot-scope="scope">
              <el-button
                type="warning"
                size="mini"
                @click="editWatchRisk(scope.row.uid)"
              >
                Edit
              </el-button>
              <el-button
                type="danger"
                size="mini"
                @click="deleteWatchRisk(scope.row.uid, scope.row.name)"
              >
                Del
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>

    <el-dialog
      :title="titleDialog"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formData"
        :model="formData"
        :rules="formDataRules"
        label-width="120px"
        size="mini"
      >
        <el-form-item label="Name" prop="name">
          <el-input v-model="formData.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Exactly Match">
          <el-select v-model="formData.exactlyMatch">
            <el-option label="Yes" :value="true"></el-option>
            <el-option label="No" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="submitWatchRisk" :loading="submitting"
          >Submit</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMainWatchRisk,
  getMainWatchRiskByUID,
  createMainWatchRisk,
  putMainWatchRisk,
  deleteMainWatchRisk,
} from "@/api/watch-risk";
export default {
  data() {
    return {
      loading: false,
      submitting: false,
      dialogFormVisible: false,
      actionDialog: "add",
      editUID: "",
      titleDialog: "Create Watch Risk",
      tableData: [],
      formData: {
        name: "",
        exactlyMatch: false,
      },
      formDataRules: {
        name: [
          { required: true, message: "Please input name", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    getMainWatchRisk() {
      this.loading = true;
      getMainWatchRisk().then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.tableData = data;
        }
      });
    },
    createMainWatchRisk(){
      this.dialogFormVisible = true; 
      this.actionDialog='add'
      this.titleDialog = "Create Watch Risk"
    },
    submitWatchRisk() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.submitting = true;
          if(this.actionDialog === 'add'){
            createMainWatchRisk(this.formData).then(({ result, message }) => {
              this.submitting = false;
              if (result) {
                this.dialogFormVisible = false;
                this.getMainWatchRisk();
                this.resetForm();
              }else{
                this.$message.error(message);
              }
            });
          }else{
            putMainWatchRisk(this.editUID, this.formData).then(({result, message})=>{
              this.submitting = false;
              if(result){
                this.dialogFormVisible = false;
                this.editUID = ""
                this.getMainWatchRisk();
                this.resetForm();
              }else{
                this.$message.error(message);
              }
            })
          }

        }
      });
    },
    editWatchRisk(uid) {
      this.loading = true;
      this.editUID = uid;
      this.titleDialog = "Edit Watch Risk";
      getMainWatchRiskByUID(uid).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.formData.name = data.name;
          this.formData.exactlyMatch = data.exactlyMatch ? true : false;
          this.actionDialog = "edit";
          this.dialogFormVisible = true;
        }
      });
      
    },
    deleteWatchRisk(uid, name) {
      this.$confirm(
        `This will delete ${name} . Continue?`,
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          deleteMainWatchRisk( uid ).then(({ result, message }) => {
            this.loading = false;
            if (result) {
              this.getMainWatchRisk();
            } else {
              this.$message.error(message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    resetForm(){
      this.formData.name = ""
      this.formData.exactlyMatch = false
    }
  },
  mounted() {
    this.getMainWatchRisk();
  },
};
</script>

<style lang="scss">
.watchRisk-main-content {
  padding: 20px;
}
</style>